import http from "../../core/services/http.service";

const ConditionReportsService = {
  getConditionReports(params = null) {
    return http.get(`/api/v1/inventories/condition-reports/`, {params});
  },
  getConditionReport(uuid, params = null) {
    return http.get(`/api/v1/inventories/condition-reports/{uuid}/`, {params});
  },
  createConditionReport(data, expand = '') {
    return http.post(`/api/v1/inventories/condition-reports/?expand=${expand}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  updateConditionReport(id, data, expand = '') {
    return http.put(`/api/v1/inventories/condition-reports/${id}/?expand=${expand}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  updateConditionReportPartially(id, data, expand = '') {
    return http.patch(`/api/v1/inventories/condition-reports/${id}/?expand=${expand}`, data);
  },
  removeConditionReport(id) {
    return http.delete(`/api/v1/inventories/condition-reports/${id}/`);
  },
  getNextVersion(inventory_uuid) {
    return http.get(`/api/v1/inventories/condition-reports/${inventory_uuid}/max_version/`)
  },
};

export default ConditionReportsService;
